import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadablePenaltyRoutes = Loadable(
  './PenaltyRoutes',
  () => import(/* webpackChunkName: "Penalty" */ './PenaltyRoutes'),
  () => [(require as any).resolveWeak('./PenaltyRoutes')]
);
